import React from "react";
import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import Work from "./Work";
function Index() {
  return (
    <>
      <Home></Home>
      <About></About>
      <Work></Work>
      <Contact></Contact>
    </>
  );
}

export default Index;
